import React from "react";
import { StatusSelect } from "./StatusSelect";
import { fmtDate, locLabel, typeLabel, condLabel } from "./api";

const th = "px-4 py-3 text-left text-[11px] font-semibold uppercase tracking-wider text-[#9a9488]";
const td = "px-4 py-3 align-top text-[14px] text-[#403d35]";

const Empty = ({ cols }) => (
  <tr><td colSpan={cols} className="px-4 py-12 text-center text-[14px] text-[#9a9488]" data-testid="admin-empty">Aucune demande pour le moment.</td></tr>
);

export const ContactsTable = ({ items, onStatus }) => (
  <table className="w-full min-w-[900px]" data-testid="admin-contacts-table">
    <thead className="border-b border-[#ece5d8]"><tr>
      {["Date", "Nom", "Coordonnées", "Message", "Page", "Statut"].map((h) => <th key={h} className={th}>{h}</th>)}
    </tr></thead>
    <tbody>
      {items.length === 0 && <Empty cols={6} />}
      {items.map((c) => (
        <tr key={c.id} className="border-b border-[#f1ebe0] last:border-b-0" data-testid={`admin-contact-row-${c.id}`}>
          <td className={`${td} whitespace-nowrap`}>{fmtDate(c.created_at)}</td>
          <td className={`${td} font-semibold text-[#26241F]`}>{c.name}</td>
          <td className={td}>
            <a href={`mailto:${c.email}`} className="block text-[#8a6a35] hover:underline">{c.email}</a>
            {c.phone && <span className="text-[13px] text-[#6e6a62]">{c.phone}</span>}
          </td>
          <td className={`${td} max-w-[340px] whitespace-pre-line`}>{c.message || "—"}</td>
          <td className={`${td} text-[13px] text-[#6e6a62]`}>{c.source || "—"}</td>
          <td className={td}><StatusSelect value={c.status} onChange={(v) => onStatus(c.id, v)} testId={`admin-contact-status-${c.id}`} /></td>
        </tr>
      ))}
    </tbody>
  </table>
);

export const EstimationsTable = ({ items, onStatus }) => (
  <table className="w-full min-w-[900px]" data-testid="admin-estimations-table">
    <thead className="border-b border-[#ece5d8]"><tr>
      {["Date", "Localisation", "Bien", "État", "Loyer estimé", "Statut"].map((h) => <th key={h} className={th}>{h}</th>)}
    </tr></thead>
    <tbody>
      {items.length === 0 && <Empty cols={6} />}
      {items.map((e) => (
        <tr key={e.id} className="border-b border-[#f1ebe0] last:border-b-0" data-testid={`admin-estimation-row-${e.id}`}>
          <td className={`${td} whitespace-nowrap`}>{fmtDate(e.created_at)}</td>
          <td className={`${td} font-semibold text-[#26241F]`}>{locLabel(e.location)}</td>
          <td className={td}>{typeLabel(e.type)} · {e.surface} m² · {e.furnished ? "meublé" : "vide"}</td>
          <td className={td}>{condLabel(e.condition)}</td>
          <td className={td}>
            <span className="font-semibold text-[#26241F]">{e.monthly?.toLocaleString("fr-FR")} €</span>
            <span className="block text-[12px] text-[#9a9488]">{e.low?.toLocaleString("fr-FR")} – {e.high?.toLocaleString("fr-FR")} €</span>
          </td>
          <td className={td}><StatusSelect value={e.status} onChange={(v) => onStatus(e.id, v)} testId={`admin-estimation-status-${e.id}`} /></td>
        </tr>
      ))}
    </tbody>
  </table>
);
